import { Course } from 'redux/schemas/models/course';
import { MentoringProgram } from 'redux/schemas/models/mentoring-programs';


export enum SortAttr {
  LAST_ACTIVITY_DATE = 'last_activity_date',
  RELEASE_DATE = 'release_date',
  START_DATE = 'official_release_date',
  END_DATE = 'end_date',
  CLOSE_DATE = 'close_date',
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export enum OfferingTypes {
  COURSE = 'course',
  JOURNEY = 'journey',
  MENTORSHIP_PROGRAM = 'mentorship_program',
}

export type CourseOrMentorshipProgram = Course & { type: OfferingTypes.COURSE | OfferingTypes.JOURNEY }
| MentoringProgram & { type: OfferingTypes.MENTORSHIP_PROGRAM, enrolledUsersCount: number, catalogId?: string };
// see GET_CURRENT_LEARNING endpoint for why catalogId is included

